'use client';

export interface AudioTranscriptionEventDetail {
  text: string;
  language: string | null;
  source: string;
  model: string;
  timestamp: number;
  raw?: unknown;
}

export type AudioTranscriptionEventHandler = (detail: AudioTranscriptionEventDetail) => void;

export class AudioTranscriptionEventBus {
  public static readonly EVENT = 'audio-transcription:complete';

  private static readonly subscribers = new Set<AudioTranscriptionEventHandler>();

  private constructor() {}

  public static emit(detail: AudioTranscriptionEventDetail): void {
    for (const handler of Array.from(AudioTranscriptionEventBus.subscribers)) {
      try {
        handler(detail);
      } catch (error) {
        console.error('Audio transcription event handler failed', error);
      }
    }
  }

  public static subscribe(handler: AudioTranscriptionEventHandler): () => void {
    AudioTranscriptionEventBus.subscribers.add(handler);
    return () => {
      AudioTranscriptionEventBus.subscribers.delete(handler);
    };
  }
}
